import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';



import { ApmTranslatePipe } from '@mitsubishi/core';
import { ButtonComponent } from '@mitsubishi/shared/ui';





@Component({
  selector: 'apm-page-not-authorized',
  imports: [RouterLink, ButtonComponent, ApmTranslatePipe],
  templateUrl: './not-authorized-page.component.html',
})
export class NotAuthorizedPageComponent {}
